import { useEffect, useState } from "react";
import { ONE_DAY_IN_MS } from "@/lib/utils";
import { LocalStorageKeys } from "@/shared/types/common";

export function useCountAttemptToConfirmPhone() {
	const [attemptToConfirmPhone, setAttemptToConfirmPhone] = useState(0);

	useEffect(() => {
		const currentDate = Date.now();
		const storedAttempts = sessionStorage.getItem(
			LocalStorageKeys.attemptToConfirmPhone,
		);
		const storedDate = sessionStorage.getItem(
			LocalStorageKeys.lastAttemptToConfirmPhoneDate,
		);

		if (storedDate && currentDate - Number(storedDate) > ONE_DAY_IN_MS) {
			setAttemptToConfirmPhone(0);
			sessionStorage.setItem(LocalStorageKeys.attemptToConfirmPhone, "0");
			sessionStorage.setItem(
				LocalStorageKeys.lastAttemptToConfirmPhoneDate,
				String(currentDate),
			);
		} else if (storedAttempts) {
			setAttemptToConfirmPhone(Number(storedAttempts) || 0);

			if (!storedDate) {
				sessionStorage.setItem(
					LocalStorageKeys.lastAttemptToConfirmPhoneDate,
					String(currentDate),
				);
			}
		}
	}, []);

	return { attemptToConfirmPhone, setAttemptToConfirmPhone };
}
